module.exports = __webpack_public_path__ + "static/img/banner3.d4e8785.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/banner3.jpg
// module id = 9ym/
// module chunks = 1